export type ManageFirmOverviewServiceType =
  | "total"
  | "accounting"
  | "investmentBanking"
  | "legal";

export type ManageFirmOverviewServiceKey = Exclude<
  ManageFirmOverviewServiceType,
  "total"
>;

export type ManageFirmOverviewSummaryRow = {
  key: ManageFirmOverviewServiceType;
  label: string;
  uniqueFirmsNoMultipleJurisdictions: number;
  primaryJurisdictionsRepresentation: number;
  secondaryJurisdictionsRepresentation: number | null;
  professionals: number | null;
};

export type PrimaryJurisdictionRow = {
  firmId: string;
  firmName: string;
  shortId: string;
  jurisdiction: string;
  region: string;
  membershipType: string;
  professionals: number;
};

export type ManageFirmProfessionalProfilesDatabaseInformation = {
  totalOfficesOfMemberFirms: number;
  totalIndividualProfiles: number;
  totalIndividualProfilesWsgJurisdictions: number;
  totalHiddenProfiles: number;
};

export type ManageFirmProfessionalProfilesReportedByFirm = {
  totalProfessionalsWorldwide: number;
  totalProfessionalsInWsgJurisdictions: number;
};

export type ManageFirmProfessionalProfilesResponse = {
  databaseInformation: ManageFirmProfessionalProfilesDatabaseInformation;
  reportedByFirm: ManageFirmProfessionalProfilesReportedByFirm;
};

export type ManageFirmWsgContactsResponse = {
  primaryContactsForWsg: number;
  secondaryContactsForWsg: number;
  primarySecondaryLiaisonContactsForWsg: number;
  marketingContacts: number;
  itContacts: number;
  accountingContacts: number;
  socialMediaContacts: number;
  hrContacts: number;
  dataAdministratorsMain: number;
  dataAdministratorsBranch: number;
};

export type MultiplePrimaryJurisdictionMemberRow = {
  officeId: string;
  firmId: string;
  firmName: string;
  jurisdiction: string;
  region: string;
  companyId: string;
  dateJoined: string | null;
  legacyTypeListing: string;
};

export type SecondaryJurisdictionMemberRow = MultiplePrimaryJurisdictionMemberRow;

export type ManageFirmOverviewResponse = {
  rows: ManageFirmOverviewSummaryRow[];
  primaryJurisdictionsByServiceType: Record<
    ManageFirmOverviewServiceKey,
    PrimaryJurisdictionRow[]
  >;
  professionalProfiles: ManageFirmProfessionalProfilesResponse;
  wsgContacts: ManageFirmWsgContactsResponse;
  secondaryJurisdictionMembers: SecondaryJurisdictionMemberRow[];
  multiplePrimaryJurisdictionMembers: MultiplePrimaryJurisdictionMemberRow[];
};

export const MANAGE_FIRM_OVERVIEW_SERVICE_LABELS: Record<
  ManageFirmOverviewServiceKey,
  string
> = {
  accounting: "Accounting",
  investmentBanking: "Investment Banking",
  legal: "Legal Services",
};
